<template>
  <div>
    <transition name="fade">
      <delete-account-popup
        v-if="showDeleteAccount"
        :team="team"
        :description="$t('deleteAccountDescription')"
        @close="showDeleteAccount = false"
        @account-deleted="(payload) => accountDeleted(payload.password,payload.teamName)"
      />
    </transition>
    <section>
      <single-setting
        v-if="!editProfile"
        id="edit-profile"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Company Profile.svg')"
        :title="$t('profile')"
      >
        <div id="avatar-name-wrapper">
          <div
            id="avatar-wrapper"
            class="file-avatar file-upload fullspan"
          >
            <img
              v-if="getURL(team)"
              :src="getURL(team)"
              class="team-icon"
            >
            <div
              v-else
              class="team-icon default-team-icon"
            >
              <p>
                {{ teamName.slice(0, 1).toUpperCase() }}
              </p>
            </div>
          </div>
          <div class="team-name-text">
            {{ teamName }}
          </div>
        </div>
        <button
          class="clavo-button secondary"
          @click="showEditProfile"
        >
          {{ $t('update') }}
        </button>

        <!--                <div id="avatar-wrapper" class="file-avatar file-upload fullspan">-->
        <!--                    <div class="custom-upload">-->
        <!--                        <input type="file" accept="image/*" @change="uploadLogo">-->
        <!--                        <div class="change-logo"-->
        <!--                             v-if="!customLogo">-->
        <!--                            <img class="team-icon"-->
        <!--                                 :src="require('@/assets/_desktop/_sidebar/plus.svg')"-->
        <!--                                 :alt="$t('altPlus')">-->
        <!--                        </div>-->
        <!--                        <img class="change-logo" :src="getURL(this.team)">-->
        <!--                        <button class="clavo-button clavo-button-action"-->
        <!--                                @click="uploadLogo">-->
        <!--                            {{ customLogo ? $t('logoChange') : $t('logoUpload') }}-->
        <!--                        </button>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <editable-input id="input-name-wrapper"-->
        <!--                                reference="name"-->
        <!--                                :title="$t('name')"-->
        <!--                                v-model="teamName"-->
        <!--                                :incorrectValueMsg="$t('nameCannotBeEmpty')"-->
        <!--                                :restoreValueOnIncorrect="true"/>-->
        <!--                <editable-input id="input-business-name-wrapper"-->
        <!--                                reference="businessName"-->
        <!--                                :title="$t('businessLegalName')"-->
        <!--                                v-model="teamBusinessName"/>-->
      </single-setting>
      <single-setting
        v-else
        id="edit-profile"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Company Profile.svg')"
        :title="$t('profile')"
      >
        <div class="edit-team-icon-wrapper">
          <div class="label">
            {{ $t('teamIcon') }}
          </div>

          <label
            for="file-input"
            class="custom-upload"
          >
            <img
              v-if="imageSrc"
              class="team-icon"
              :src="imageSrc"
              :alt="$t('altPlus')"
            >
            <img
              v-else-if="getURL(team)"
              :src="getURL(team)"
              class="team-icon"
            >
            <img
              v-else
              class="team-icon"
              :src="require('@/assets/_desktop/_settings/upload-avatar.svg')"
              :alt="$t('altPlus')"
            >

            {{ $t('uploadIcon') }}
          </label>
          <input
            id="file-input"
            style="display: none"
            type="file"
            accept="image/*"
            @change="uploadLogoPreview"
          >
        </div>
        <editable-input
          id="input-name-wrapper"
          v-model="teamTemporaryName"
          reference="name"
          :title="$t('teamName')"
          :incorrect-value-msg="$t('nameCannotBeEmpty')"
          :restore-value-on-incorrect="true"
        />
        <div class="buttons-row">
          <button
            class="clavo-button primary"
            @click="uploadData"
          >
            {{ $t('save') }}
          </button>
          <button
            class="clavo-button secondary"
            @click="showEditProfile"
          >
            {{ $t('cancel') }}
          </button>
        </div>
      </single-setting>
      <single-setting
        id="delete-account"
        class="single-setting"
        :icon="require('@/assets/_desktop/_settings/_icons/Delete.svg')"
        :title="$t('deleteTeam')"
        :description="$t('deleteAccountDescription')"
      >
        <button
          id="delete-account-button"
          class="clavo-button clavo-button-danger-secondary"
          @click="openDeletePopup"
        >
          {{ $t('deleteTeam') }}
        </button>
      </single-setting>
    </section>
  </div>
</template>

<script>
import Constants from '@/components/Constants'
import Validation from '@/components/Validation'
import SingleSetting from '@/components/Settings/SingleSetting'
import EditableInput from '@/components/UI/EditableInput'
import DeleteAccountPopup from '@/components/Settings/DeleteAccountPopup'
import * as UTILS from '@/components/utils'
import ParseFunctions from '@/components/ParseFunctions'
import EventBus from '@/EventBus'

export default {
  components: {
    DeleteAccountPopup,
    SingleSetting,
    EditableInput,
  },
  mixins: [Constants, Validation, ParseFunctions],
  props: {
    team: Object,
  },
  data() {
    return {
      showDeleteAccount: false,
      showInfoBar: false,
      infoBarMsg: '',
      infoBarError: false,
      teamBusinessName: '',
      settings: null,
      address: '',
      secondAddress: '',
      zipCode: '',
      city: '',
      stateProvince: '',
      editProfile: false,
      imageSrc: null,
      imageFile: null,
      teamTemporaryName: '',
      teamName: '',
    }
  },
  computed: {
    customLogo() {
      return this.getURL(this.team)
    },
  },
  async created() {
    this.settings = this.team['settings']
    this.teamTemporaryName = this.team['name']
    this.teamName = this.team['name']
  },
  methods: {
    showEditProfile() {
      this.editProfile = !this.editProfile
    },
    getURL(team) {
      return team.logo ? team.logo._url : null
    },
    async uploadLogoPreview(e) {
      this.imageFile = e
      var file = e.target.files[0]
      this.imageSrc = URL.createObjectURL(file)
    },
    async uploadData() {
      let e = this.imageFile
      let _this = this
      if (e) {
        let files = e.target.files || e.dataTransfer.files
        let reader = new FileReader()
        reader.onload = async e => {
          // deleting a line below causes errors on several machines; It updates database properly.
          // The following line updates database as well but it may not work, it returns ParseObject
          // which is necessary to update icons without refreshing
          _this.$store.commit('setShowProgressBar', true)
          let res
          try{
            res = await _this.setTeamAvatar(_this.team.teamId, e.target.result)
          }catch(err){
            EventBus.$emit('new-info-bar-msg', {
              msg: this.$t('logoNotChanged'),
              error: true,
            })
            _this.$store.commit('setShowProgressBar', false)
          }

          // console.log('upload data res=')
          // console.dir(res)

          if (res && res.status === 'ok') {
            _this.team.logo = res.logo
            // console.log('teamGeneralSettings _this.team = ')
            // console.dir(_this.team)
            _this.showEditProfile()
            EventBus.$emit('reload-teams')

          } else {
            if (res.message === 'request entity too large'){
              EventBus.$emit('new-info-bar-msg', {
                msg: this.$t('fileToolLarge'),
                error: true,
              })
            }else{
              EventBus.$emit('new-info-bar-msg', {
                msg: this.$t('logoNotChanged'),
                error: true,
              })
            }
          }
          this.$store.commit('setShowProgressBar', false)
        }
        reader.readAsDataURL(files[0])
      }
      
      if (this.teamName !== this.teamTemporaryName){
        let res = await this.setTeamName(this.team.teamId, this.teamTemporaryName)
        if (res.status === 'ok') {
          this.teamName = this.teamTemporaryName
          _this.team.name = this.teamTemporaryName
          this.showEditProfile()
        } else {
          this.showServerError(res)
          this.showEditProfile()
        }
      }
      EventBus.$emit('reload-teams')
    },
    openDeletePopup(){
      if(this.$store.state.teams.length > 0) {
        this.showDeleteAccount = true
      }
    },
    async accountDeleted(password, teamName) {
      this.$store.commit('setShowProgressBar', true)
      this.infoBarMsg = this.$t('teamDeletedSuccess')
      this.showInfoBar = true
      this.showDeleteAccount = false
      // console.log('implement deleting team')
      let deletedTeamId = this.team.teamId

      let teamIdToSwitch = undefined
      if (this.$store.state.teams[0].teamId == deletedTeamId && this.$store.state.teams.length > 1) {
        teamIdToSwitch = this.$store.state.teams[1].teamId
      } else teamIdToSwitch = this.$store.state.teams[0].teamId

      let nrOfTeamsBeforeDelete = this.$store.state.teams.length
      let res = await this.deleteTeam(this.team.teamId, password, teamName)

      if(res.status === 'ok') {
        if (nrOfTeamsBeforeDelete > 1){
          await this.$router.push({
            path: '/',
            query: { teamId: teamIdToSwitch },
            hash: 'Calendar',
          })
          EventBus.$emit('component-selected', { componentName: 'Calendar', teamId: teamIdToSwitch, type: 'team' })
          EventBus.$emit('team-calendar-selected', { teamId: teamIdToSwitch })
        }else{
          await this.$router.push({
            path: '/onboarding',
            query: { stage: 'createOrDelete' }
          })
        }
        this.showMessage('teamDeletedSuccess')      
      }else{
        this.showServerError(res)
      }
      this.$store.commit('setShowProgressBar', false)
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  margin: 35px;
}
.single-setting {
  margin-bottom: 60px;

  .photo-upload-default {
    height: 50px;
    width: 50px;
    border-radius: 50px;
  }

  .team-icon {
    cursor: pointer;
    height: 50px;
    width: 50px;
    border-radius: 50px;
    margin-right: 20px;
    object-fit: cover;
  }
  #avatar-name-wrapper {
    grid-column: 1 / span 3;
    display: flex;
    flex-direction: row;
    align-items: center;
    // gap: 16px;
  }

  #avatar-wrapper {
    .team-icon {
      vertical-align: middle;
      width: 50px;
      height: 50px;
      border-radius: 50px;
      //margin: 6px 6px 6px 0;

      &.default-team-icon {
        background-color: $blue;
        display: flex;
        p {
          display: flex;
          @include font-rule('averta-semibold');
          width: 100%;
          line-height: 30px;
          font-size: 30px;
          color: #ffffff;
          align-items: center;
          justify-content: center;
          text-align: center;

          margin: 0 0 0 0;
        }
      }
    }
    img {
      height: 50px;
      width: 50px;
      border-radius: 50px;
      object-fit: cover;
    }
  }
  .team-name-text {
    color: $black;
    @include font-rule('averta-bold');
    font-size: 20px;
    letter-spacing: 0;
    line-height: 36px;
  }
  button {
    justify-self: start;
    align-self: flex-start;
  }

  .edit-team-icon-wrapper {
    grid-column: 1 / span 2;
    img,
    .photo-upload-default {
      margin-right: 16px;
    }
  }
  #input-name-wrapper {
    grid-column: 1 / span 2;
  }
  .buttons-row {
    grid-column: 1 / span 3;
    button {
      &:first-of-type {
        margin-right: 20px;
      }
    }
    @include respond-below(xs) {
      display: flex;
    }
  }

  .label {
    @include label;

    margin-bottom: 12px;
  }
  .custom-upload {
    @include font-link;
    cursor: pointer;

    display: flex;
    flex-direction: row;
    align-items: center;

    overflow: hidden;
  }
}
@include respond-below(sm) {
  section {
    margin: 20px;
  }
}
@include respond-below(xs) {
  .single-setting {
    button {
      align-self: stretch;
      flex: 1;
      min-width: 0px;
    }
  }
}
</style>
